import type {BaseDocumentContentType, ListResponseType} from 'sweet-types';

type OptionsType<M extends {url?: string} | unknown> = {
  addsListId: boolean;
  idGetter: (item: M) => string;
};

export function createTagsListFromResponse<T extends string, M>(
  type: T,
  response: ListResponseType<M, any> | undefined,
  {addsListId, idGetter}: OptionsType<M>
): Array<{type: T; id: string}> {
  const tags: Array<{type: T; id: string}> = [];

  if (addsListId) {
    tags.push({type, id: 'list'});
  }

  return tags.concat(
    response != null
      ? response.results.map(
          (item) =>
            ({
              type,
              id: idGetter(item),
            } as const)
        )
      : []
  );
}

export function providesTagsByURL<T extends string, M extends {url: string}>(
  type: T
) {
  const tagHandler = (response) =>
    createTagsListFromResponse<T, M>(type, response, {
      addsListId: true,
      idGetter: (item) => item.url,
    });
  return tagHandler;
}

const RTK_TAGS_LU: Record<BaseDocumentContentType, Array<string>> = {
  procedure: ['PROCEDUREHASHID', 'PROCEDURE'],
  proceduregroup: ['PROCESS', 'PROCESSHASHID'],
  policy: ['POLICY', 'POLICYHASHID'],
};

type Props = {
  contentType: BaseDocumentContentType;
  url?: string;
};
export function tagsRelatedTo({contentType, url}: Props) {
  const tags = RTK_TAGS_LU[contentType];
  if (tags && url) {
    return tags.map((type) => ({
      type,
      id: url,
    }));
  } else {
    return [];
  }
}
